import type { JsonDataItem, TypeOrArray } from '../../../types';
import type { VisibilityCondition } from '../../visibility-condition.interfaces';
import type {
  ITargetValueConverter,
  ValueConverterReturnType,
} from './i-target-value-converter';

export class BooleanTargetValueConverter implements ITargetValueConverter {
  convert(
    condition: VisibilityCondition,
    data: JsonDataItem,
  ): TypeOrArray<ValueConverterReturnType> {
    const dataItem = condition.sourceFieldId
      ? Boolean(data[condition.sourceFieldId])
      : false;
    return [
      dataItem,
      Boolean(condition.targetValue),
      condition.negation || false,
      condition.filterOperator || 'EQUALS',
    ];
  }
}
